import React from "react";
import {
    FormattedDate,
    FormattedMessage,
    FormattedNumber,
    FormattedTime,
    MessageDescriptor,
} from "react-intl";

import { Localisation } from "@localisation/index";
import { Locale, TranslatableMap } from "@localisation/models";
import { messages } from "../messages";

export interface DataRowInnerProps {
    message: MessageDescriptor;
    children?: React.ReactNode;
}

const DataRowInner = ({ message, children}: DataRowInnerProps) => (
    <div className="data-row">
        <span className="data-row__label">
            <FormattedMessage {...message} />
        </span>
        {" "}
        <span className="data-row__data">{children}</span>
    </div>
);

export interface DataRowProps {
    message: MessageDescriptor;
    value: string;
}

export const DataRow = ({ message, value }: DataRowProps) => (
    <DataRowInner message={message}>
        {value != null && value}
    </DataRowInner>
);

export interface DataRowDateProps {
    message: MessageDescriptor;
    value: Date;
}

export const DataRowDate = ({ message, value }: DataRowDateProps) => (
    <DataRowInner message={message}>
        {value != null &&
            <FormattedDate
                value={value}
                year="numeric"
                month="long"
                day="numeric"
                timeZone="UTC" />
        }
    </DataRowInner>
);

export interface DataRowDateTimeProps {
    message: MessageDescriptor;
    value: Date;
}

export const DataRowDateTime = ({ message, value }: DataRowDateTimeProps) => (
    <DataRowInner message={message}>
        {value != null &&
            <span>
                <FormattedDate
                    value={value}
                    year="numeric"
                    month="long"
                    day="numeric"
                />&nbsp;
                <FormattedTime value={value} />
            </span>
        }
    </DataRowInner>
);

export interface DataRowNumberProps {
    message: MessageDescriptor;
    value: number;
}

export const DataRowNumber = ({ message, value }: DataRowNumberProps) => (
    <DataRowInner message={message}>
        {value != null && <FormattedNumber value={value} />}
    </DataRowInner>
);

export interface DataRowTranslatedProps {
    message: MessageDescriptor;
    value: TranslatableMap;
    locale: Locale;
}

export const DataRowTranslated = ({ message, value, locale }: DataRowTranslatedProps) => (
    <DataRowInner message={message}>
        {value != null && Localisation.translateMap(value, locale)}
    </DataRowInner>
);

export interface DataRowBooleanProps {
    message: MessageDescriptor;
    value: boolean;
}

export const DataRowBoolean = ({ message, value }: DataRowBooleanProps) => (
    <DataRowInner message={message}>
        {value != null &&
            <FormattedMessage {...(value ? messages.buttonYes : messages.buttonNo)} />
        }
    </DataRowInner>
);

export interface DataRowExternalLinkProps {
    message: MessageDescriptor;
    value: string;
    to: string;
}

export const DataRowExternalLink = ({ message, value, to }: DataRowExternalLinkProps) => (
    <DataRowInner message={message}>
        {value != null &&
            <a href={to} target="_blank">{value}</a>
        }
    </DataRowInner>
);
